import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const PTZSmallCapsuleButton = styled.div`
  &.material-symbols-rounded {
    color: var(--text-secondary);
    background-color: var(--tonal);
    font-variation-settings: 'FILL' 1;
    font-size: 1.375rem;
    width: 3rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    &:hover {
      cursor: pointer;
      color: var(--filled-blue-deep);
      background-color: var(--tonal-deep-blue);
      &:active {
        color: var(--primary);
        background-color: var(--tonal-blue);
      }
    }
    &.left {
      border-radius: 1rem 0 0 1rem;
      border-right: 1px solid var(--outline);
    }
    &.right {
      border-radius: 0 1rem 1rem 0;
    }
  }
`;

type PTZCapsuleButtonProps = { position: 'left' | 'right'; data: { mouseDown: () => void; icon: string }; mouseUp: () => void };

const PTZCapsuleButton = ({ data, position, mouseUp }: PTZCapsuleButtonProps) => {
  return (
    <PTZSmallCapsuleButton //
      className={`material-symbols-rounded ${position}`}
      onMouseDown={data.mouseDown}
      onMouseUp={mouseUp}
      role='presentation'
    >
      {data.icon}
    </PTZSmallCapsuleButton>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .capsuleName {
    letter-spacing: initial;
    font-size: 0.75rem;
    font-weight: 600;
    user-select: none;
    color: var(--text-secondary);
  }
  .capsuleContainer {
    display: flex;
  }
`;

type Props = {
  data: {
    name: string; //
    title: string;
    left: { mouseDown: () => void; icon: string };
    right: { mouseDown: () => void; icon: string };
    mouseUp: () => void;
  };
};

const PTZInteractionControlCapsule = ({ data }: Props) => {
  const { t } = useTranslation();
  return (
    <Root>
      <span className='capsuleName'>{t(data.name)}</span>
      <div className='capsuleContainer'>
        <PTZCapsuleButton data={data.left} position='left' mouseUp={data.mouseUp} />
        <PTZCapsuleButton data={data.right} position='right' mouseUp={data.mouseUp} />
      </div>
    </Root>
  );
};

export default PTZInteractionControlCapsule;
